import React from "react";
import { useSimulationDataContext } from "../contexts/SimulationDataContext";

/**
 * Simplified hook that consumes shared simulation data from context
 * No more duplicate API calls - data is fetched once in the provider
 */
export const useSimulationData = (csvData, onLoadingStateChange) => {
  const context = useSimulationDataContext();
 
  // Communicate loading state to parent component
  React.useEffect(() => {
    if (onLoadingStateChange) {
      const loadingState =
        context.isLoading || (!context.error && context.dailyData.length === 0);
      onLoadingStateChange(loadingState);
    }
  }, [context.isLoading, context.dailyData.length, onLoadingStateChange]);

  return {
    // Data from context
    dailyData: context.dailyData,
    allTimeData: context.allTimeData,
    simulations: context.simulations,
    storageAccountName: context.storageAccountName,
    devices: context.devices,

    // Loading states from context
    isLoading: context.isLoading,
    loadingMessage: context.loadingMessage,
    error: context.error,

    // Functions from context
    refetchData: context.refetchData,
  };
};
